export class ParkingStorageService {
    constructor() { }
    addParkingToMap(parking) {
        const parkingsJson = localStorage.getItem('oldParkings');
        const oldParkings = new Map(parkingsJson ? JSON.parse(parkingsJson) : []);
        oldParkings.set(parking.plate, parking);
        localStorage.setItem('oldParkings', JSON.stringify([...oldParkings]));
    }
    getParkingById(parkingId) {
        const parkingsJson = localStorage.getItem('oldParkings');
        const oldParkings = new Map(parkingsJson ? JSON.parse(parkingsJson) : []);
        const parking = [...oldParkings.values()].find(p => p.id == parkingId);
        return parking;
    }
    getCurrentParkingByClientId(clientId) {
        const parkingJson = localStorage.getItem('CurrentParking');
        const oldParking = new Map(parkingJson ? JSON.parse(parkingJson) : []);
        return oldParking.get(clientId);
    }
    deleteParkingToMap(parkingId) {
        const parkingsJson = localStorage.getItem('oldParkings');
        const oldParkings = new Map(parkingsJson ? JSON.parse(parkingsJson) : []);
        const parking = [...oldParkings.values()].find(p => p.id == parkingId);
        oldParkings.delete(parking.plate);
        localStorage.setItem('oldParkings', JSON.stringify([...oldParkings]));
    }
}
